import React, { useState } from "react";
import { useEffect } from "react";
import RoleTile from "../../Component/RoleTile";
import { Button } from 'primereact/button';
import { useLocalStorage, useMountEffect } from 'primereact/hooks';
import { useNavigate } from "react-router-dom";
import { ajoutRole, enleveRole } from "../../redux/partieSlice";
import { useSelector, useDispatch } from "react-redux";




const GameCreation = ({ Partie, NbPlayer, onCheckboxChange, onInputNumberChange }) => {

  const [rolesAJoue, setRolesAJoue] = useLocalStorage([], 'RolesPartie');
  const [NombreJoueur, setNbJoueur] = useState(0);
  const [roles, setRoles] = useState([]);
  let navigate = useNavigate();

  const partie = useSelector((state) => state.partie);
  const dispatch = useDispatch();


  const handleNbPlayer = (NbPlayer) => {
    setNbJoueur(NbPlayer);
  };

  useMountEffect(() => {
    fetch(`${process.env.REACT_APP_WEREWOLVES_API_URL}/Role`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setRoles(data);
      })
      .catch((err) => {
        console.log(err.message);
      });
  })

  function CheckNbplayer(nbdiff) {
    console.log(nbdiff);

    return null;
  }

  function AlerteNbplayer(visible) {

    return null;
  }

  function onCheckboxChange(checked, role) {
    var updatedRolesAJoue = [];
    if (checked) {
      updatedRolesAJoue = [...rolesAJoue, role];
    } else {
      updatedRolesAJoue = rolesAJoue.filter(x => x.order !== role.order);
    }
    // Mettre à jour l'état avec la nouvelle liste
    setRolesAJoue(updatedRolesAJoue);
  }

  function onChangeNumberPlayer(valueplayer) {
    setNbJoueur(valueplayer);
  }

  function launchGame() {
    navigate("/game");
  }

  function roletile(role) {
    return (<RoleTile role={role} checked={partie.some(e => e.order === role.order)} onCheckboxChange={onCheckboxChange} />)
  }

  function listRole(roles, type) {
    return (
      <div className="wrapper">
        {roles.filter((role) => { return role.type == type })
          .map((role) => (
            roletile(role)
          ))}
      </div>
    )
  }

  useEffect(() => {
    var roletoplay = roles.filter(x => rolesAJoue.some(y => y == x.order)).reduce((a, v) => a = a + v.nb, 0);
    CheckNbplayer(NombreJoueur - roletoplay);
  }, [rolesAJoue, NombreJoueur])

  return (
    <div className="gameCreation">
      <AlerteNbplayer />
      <div>
        Nombre de joueurs : <input type="number" name="nbPlayer" id="nbplayer" value={NombreJoueur} onChange={(e) => handleNbPlayer(e.target.value)} />
        <Button label="Reset Partie" onClick={() => { setRolesAJoue([]); setNbJoueur(0); roles.forEach(role => dispatch(enleveRole(role.order))); }} />
      </div>
      <h3>Villageois</h3>
      {listRole(roles, 1)}
      <br />
      <h3>Loups-Garous</h3>

      {listRole(roles, 2)}
      <br />
      <h3>Indépendants</h3>

      {listRole(roles, 3)}
      <br />
      <h3>Villageois Spéciaux</h3>

      {listRole(roles, 4)}
      <div>
        <Button onClick={launchGame} label="Commencer la Partie" />
      </div>
    </div>
  )
}

export default GameCreation;